export default __webpack_public_path__ + "static/media/atencaoIcon.a1d42f08.svg";